// extracted by mini-css-extract-plugin
export default {"point":"Point_point__gipve","number":"Point_number__D-VTS","content":"Point_content__leXjU","text":"Point_text__A3N+Q"};